import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

import BaseButton from "@/components/ui/BaseButton.vue";

/** Toolbar wrapper kept for existing imports; buttons are ui/BaseButton (solid). */
interface Props {
  loading?: boolean
  showDownloadCSV?: boolean
  showDownloadJSON?: boolean
  showRefresh?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButtonsComponent',
  props: {
    loading: { type: Boolean, default: false },
    showDownloadCSV: { type: Boolean, default: true },
    showDownloadJSON: { type: Boolean, default: true },
    showRefresh: { type: Boolean, default: true }
  },
  emits: ["download-csv", "download-json", "refresh"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.showDownloadCSV)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 0,
          variant: "secondary",
          icon: "fa fa-download",
          class: "me-2",
          disabled: __props.loading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('download-csv')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('panel.table.downloadCsv')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (__props.showDownloadJSON)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 1,
          variant: "secondary",
          icon: "fa fa-download",
          class: "me-2",
          disabled: __props.loading,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('download-json')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('panel.table.downloadJson')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (__props.showRefresh)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 2,
          solid: "",
          variant: "primary",
          icon: "fa fa-refresh",
          disabled: __props.loading,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refresh')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('panel.table.refresh')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "custom-actions")
  ]))
}
}

})